/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

function hoverImage(blockId){
  let image1 = document.querySelector(".custom__item--"+blockId+" .custom-content-image1");
  let image2 = document.querySelector(".custom__item--"+blockId+" .custom-content-image2");

  if(image1.classList.contains("active")){
    image1.classList.remove("active")
    image2.classList.add("active")

    image1.style.cssText += ';display:none !important;'
    image2.style.cssText += ';display:block !important;'
  }
  else{
    image1.classList.add("active")
    image2.classList.remove("active")

    image1.style.cssText += ';display:block !important;'
    image2.style.cssText += ';display:none !important;'
  }
}

// Floating buttons stop at footer copyright border (Mobile/Tablet only)
(function() {
  'use strict';

  // Check if device is mobile or tablet (1024px and below)
  function isMobileOrTablet() {
    return window.innerWidth <= 1024;
  }

  // Check if device is mobile (768px and below)
  function isMobile() {
    return window.innerWidth <= 768;
  }

  function init() {
    // // Check mobile/tablet once during init
    // if (!isMobileOrTablet()) {
    //   return;
    // }

    var footer = document.getElementById('footer-copyright');

    if (!footer) {
      return;
    }

    var alerted = false;
    var ticking = false;

    function update() {
      // Get floating buttons every time the function is called
      var eber = document.getElementById("eber-btn-open-widget");
      var waPopup = document.querySelector(".wa__btn_popup");
      var waChatBox = document.querySelector(".wa__popup_chat_box");
      var scrollToTopBtn = document.getElementById("scrollToTopBtn");

      var footerTop = footer.getBoundingClientRect().top;
      var vh = window.innerHeight;

      // Check if footer is entering viewport
      if (footerTop < vh) {
        if (!alerted) {
          alerted = true;
        }

        // Calculate distance to push buttons up
        var pushUp = vh - footerTop;

        // Apply new bottom position (initial + push up amount)
        // Eber button now on LEFT side, same bottom position
        if (eber) {
          var newEberBottom = 25 + pushUp;
          eber.style.setProperty("bottom", newEberBottom + "px", "important");
        }

        if (waPopup) {
          // When scroll-to-top is NOT visible: match eber-btn position (25px bottom)
          // When scroll-to-top IS visible: move up to sit above it
          // Desktop: 90px (for 50px scroll-to-top button), Mobile: 75px (for 40px button)
          var scrollToTopVisible =
            scrollToTopBtn && scrollToTopBtn.classList.contains("visible");
          var waBaseBottom = scrollToTopVisible ? (isMobile() ? 75 : 90) : 25;
          var newWaBottom = waBaseBottom + pushUp;
          waPopup.style.setProperty("bottom", newWaBottom + "px", "important");
        }

        // WhatsApp chat popup box - sits above the WhatsApp button
        if (waChatBox) {
          var scrollToTopVisible =
            scrollToTopBtn && scrollToTopBtn.classList.contains("visible");
          // Chat box base: ~65px above the WhatsApp button position
          // Desktop: 160px, Mobile: 140px
          var chatBoxBaseBottom = scrollToTopVisible
            ? isMobile()
              ? 140
              : 160
            : 110;
          var newChatBoxBottom = chatBoxBaseBottom + pushUp;
          waChatBox.style.setProperty(
            "bottom",
            newChatBoxBottom + "px",
            "important"
          );
        }

        // Scroll to top button stays fixed at 25px bottom (no floating)
      } else {
        alerted = false;

        // Reset to initial positions
        if (eber) {
          eber.style.setProperty("bottom", "25px", "important");
        }
        if (waPopup) {
          // When scroll-to-top is NOT visible: match eber-btn position (25px bottom)
          // When scroll-to-top IS visible: move up to sit above it
          // Desktop: 90px (for 50px scroll-to-top button), Mobile: 75px (for 40px button)
          var scrollToTopVisible =
            scrollToTopBtn && scrollToTopBtn.classList.contains("visible");
          var waBaseBottom = scrollToTopVisible ? (isMobile() ? 75 : 90) : 30;
          waPopup.style.setProperty("bottom", waBaseBottom + "px", "important");
        }

        // Reset WhatsApp chat popup box position
        if (waChatBox) {
          var scrollToTopVisible =
            scrollToTopBtn && scrollToTopBtn.classList.contains("visible");
          // Desktop: 160px, Mobile: 140px
          var chatBoxBaseBottom = scrollToTopVisible
            ? isMobile()
              ? 140
              : 160
            : 110;
          waChatBox.style.setProperty(
            "bottom",
            chatBoxBaseBottom + "px",
            "important"
          );
        }
        // Scroll to top button stays fixed at 25px bottom (no reset needed)
      }
    }

    function handleScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', handleScrollOrResize, { passive: true });
    window.addEventListener('resize', handleScrollOrResize, { passive: true });
    update();
  }

  function widgetsReady() {
    return !!(
      document.getElementById('footer-copyright') &&
      (document.getElementById('eber-btn-open-widget') || document.querySelector('.wa__btn_popup'))
    );
  }

  if (widgetsReady()) {
    init();
  } else {
    var giveUpTimer = setTimeout(function () {
      observer.disconnect();
      init();
    }, 10000);

    var observer = new MutationObserver(function () {
      if (widgetsReady()) {
        clearTimeout(giveUpTimer);
        observer.disconnect();
        init();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();